/**
 * Generated by orval v6.17.0 🍺
 * Do not edit manually.
 * Gatti Filtrazioni
 * OpenAPI spec version: v1
 */

export type ProprietaMisurataDataPeriod =
  (typeof ProprietaMisurataDataPeriod)[keyof typeof ProprietaMisurataDataPeriod];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProprietaMisurataDataPeriod = {
  "10s": "10s",
  "1m": "1m",
  "2m": "2m",
  "5m": "5m",
  "10m": "10m",
  "15m": "15m",
  "30m": "30m",
  "1h": "1h",
} as const;
